import React from 'react'

import css from './style.scss'

export default ({ title, children }) => (
  <div className={css.metricsCard}>
    {children}
  </div>
)
